package br.com.texeratx.boardgametimeapp.ui.screens.expansions.edit

import br.com.texeratx.boardgametimeapp.domain.usecases.games.GameOption

data class EditExpansionState(
    val expansionId: Long = 0,
    val name: String = "",
    val imageUrl: String = "",
    val bggUrl: String = "",

    val games: List<GameOption> = emptyList(),
    val selectedGameId: Long? = null,

    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val errorMessage: String? = null,
    val uiMessage: String? = null
)
